// Neon's Data API can run the first requests after a compute resume as `authenticated` before the JWT
// session is initialised. is_allowed_user() then raises PT503 ("JWT session not initialised") instead of
// letting RLS return an empty list. Retry those responses a few times; anything else passes through.
const RETRY_DELAYS_MS = [250, 500, 1000, 2000]

async function isJwtNotReady(res) {
  if (res.status !== 503) return false
  try {
    const body = await res.clone().json()
    return body?.code === 'PT503'
  } catch {
    return false
  }
}

export function createRetryFetch(baseFetch = (...args) => fetch(...args), delays = RETRY_DELAYS_MS) {
  return async (input, init) => {
    let res = await baseFetch(input, init)
    for (const delay of delays) {
      if (!(await isJwtNotReady(res))) return res
      await new Promise(resolve => setTimeout(resolve, delay))
      res = await baseFetch(input, init)
    }
    return res
  }
}
